import React from 'react'
import { useTranslation } from 'react-i18next';
import Modal from '../../components/modals/ModalFull'
import { Button, ContainerModal,  } from './SlotsElements'
import useMediaQuery from '@mui/material/useMediaQuery';
// style={{position: "absolute", top: "8%", left: "0px", width: "100%", height: "90%", border:"none",margin: "0px", padding: "0px"}}
const ModalSlots = ({open, handleClose, url}) => {
  const [t] = useTranslation('global');
  const changebtn = useMediaQuery('(min-width:750px)');
  return (
    <Modal open={open} handleClose={handleClose} children={
      <ContainerModal >
        <div className='closebtn'>
          {changebtn ? <Button onClick={handleClose}>X</Button> : <Button onClick={handleClose}>{t('buttons.go-back')}</Button>}
        </div>
        <iframe title='slots' allowFullScreen src={url}></iframe>
      </ContainerModal>
    }/>
  )
}

export default ModalSlots